// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as BestLawFirmSeoCompaniesRouteImport } from './routes/best-law-firm-seo-companies'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as CaseStudiesRouteImport } from './routes/case-studies'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as GlossaryRouteImport } from './routes/glossary'
import { Route as GuidesRouteImport } from './routes/guides'
import { Route as LawFirmSeoAuditRouteImport } from './routes/law-firm-seo-audit'
import { Route as LawyerSeoRouteImport } from './routes/lawyer-seo'
import { Route as PracticeAreasRouteImport } from './routes/practice-areas'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as CaseStudiesIndexRouteImport } from './routes/case-studies.index'
import { Route as CaseStudiesSlugRouteImport } from './routes/case-studies.$slug'
import { Route as GlossaryIndexRouteImport } from './routes/glossary.index'
import { Route as GlossarySlugRouteImport } from './routes/glossary.$slug'
import { Route as LawyerSeoIndexRouteImport } from './routes/lawyer-seo.index'
import { Route as LawyerSeoSlugRouteImport } from './routes/lawyer-seo.$slug'
import { Route as PracticeAreasIndexRouteImport } from './routes/practice-areas.index'
import { Route as PracticeAreasSlugRouteImport } from './routes/practice-areas.$slug'
import { Route as PracticeAreasBankruptcyLawyerSeoRouteImport } from './routes/practice-areas.bankruptcy-lawyer-seo'
import { Route as PracticeAreasCorporateBusinessLawyerSeoRouteImport } from './routes/practice-areas.corporate-business-lawyer-seo'
import { Route as PracticeAreasCriminalDefenseLawyerSeoRouteImport } from './routes/practice-areas.criminal-defense-lawyer-seo'
import { Route as PracticeAreasDuiDwiLawyerSeoRouteImport } from './routes/practice-areas.dui-dwi-lawyer-seo'
import { Route as PracticeAreasEmploymentLawLawyerSeoRouteImport } from './routes/practice-areas.employment-law-lawyer-seo'
import { Route as PracticeAreasEstatePlanningLawyerSeoRouteImport } from './routes/practice-areas.estate-planning-lawyer-seo'
import { Route as PracticeAreasFamilyLawLawyerSeoRouteImport } from './routes/practice-areas.family-law-lawyer-seo'
import { Route as PracticeAreasImmigrationLawyerSeoRouteImport } from './routes/practice-areas.immigration-lawyer-seo'
import { Route as PracticeAreasMedicalMalpracticeLawyerSeoRouteImport } from './routes/practice-areas.medical-malpractice-lawyer-seo'
import { Route as PracticeAreasPersonalInjuryLawyerSeoRouteImport } from './routes/practice-areas.personal-injury-lawyer-seo'
import { Route as PracticeAreasRealEstateLawLawyerSeoRouteImport } from './routes/practice-areas.real-estate-law-lawyer-seo'
import { Route as PracticeAreasTaxLawLawyerSeoRouteImport } from './routes/practice-areas.tax-law-lawyer-seo'
import { Route as PracticeAreasWorkersCompensationLawyerSeoRouteImport } from './routes/practice-areas.workers-compensation-lawyer-seo'
import { Route as ServicesIndexRouteImport } from './routes/services.index'
import { Route as ServicesSlugRouteImport } from './routes/services.$slug'
import { Route as ServicesAiSeoGeoRouteImport } from './routes/services.ai-seo-geo'
import { Route as ServicesLawFirmMarketingAnalyticsRouteImport } from './routes/services.law-firm-marketing-analytics'
import { Route as ServicesLawFirmSeoRouteImport } from './routes/services.law-firm-seo'
import { Route as ServicesLawFirmWebsiteDevelopmentRouteImport } from './routes/services.law-firm-website-development'
import { Route as ServicesLeadGenerationForLawFirmsRouteImport } from './routes/services.lead-generation-for-law-firms'
import { Route as ServicesLegalContentWritingRouteImport } from './routes/services.legal-content-writing'
import { Route as ServicesLinkBuildingForLawFirmsRouteImport } from './routes/services.link-building-for-law-firms'
import { Route as ServicesLocalSeoForLawFirmsRouteImport } from './routes/services.local-seo-for-law-firms'
import { Route as ServicesPpcForLawFirmsRouteImport } from './routes/services.ppc-for-law-firms'
import { Route as ServicesSocialMediaMarketingForLawFirmsRouteImport } from './routes/services.social-media-marketing-for-law-firms'
import { Route as ServicesTechnicalSeoForLawFirmsRouteImport } from './routes/services.technical-seo-for-law-firms'
import { Route as UkDigitalMarketingForSolicitorsRouteImport } from './routes/uk.digital-marketing-for-solicitors'
import { Route as UkLocalSeoForSolicitorsRouteImport } from './routes/uk.local-seo-for-solicitors'
import { Route as UkSeoForSolicitorsRouteImport } from './routes/uk.seo-for-solicitors'
import { Route as BlogPagePageRouteImport } from './routes/blog.page.$page'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const BestLawFirmSeoCompaniesRoute = BestLawFirmSeoCompaniesRouteImport.update({
            id: '/best-law-firm-seo-companies',path: '/best-law-firm-seo-companies',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const CaseStudiesRoute = CaseStudiesRouteImport.update({
            id: '/case-studies',path: '/case-studies',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const GlossaryRoute = GlossaryRouteImport.update({
            id: '/glossary',path: '/glossary',getParentRoute: () => rootRouteImport
          })
const GuidesRoute = GuidesRouteImport.update({
            id: '/guides',path: '/guides',getParentRoute: () => rootRouteImport
          })
const LawFirmSeoAuditRoute = LawFirmSeoAuditRouteImport.update({
            id: '/law-firm-seo-audit',path: '/law-firm-seo-audit',getParentRoute: () => rootRouteImport
          })
const LawyerSeoRoute = LawyerSeoRouteImport.update({
            id: '/lawyer-seo',path: '/lawyer-seo',getParentRoute: () => rootRouteImport
          })
const PracticeAreasRoute = PracticeAreasRouteImport.update({
            id: '/practice-areas',path: '/practice-areas',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })
const CaseStudiesIndexRoute = CaseStudiesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CaseStudiesRoute
          })
const CaseStudiesSlugRoute = CaseStudiesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => CaseStudiesRoute
          })
const GlossaryIndexRoute = GlossaryIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => GlossaryRoute
          })
const GlossarySlugRoute = GlossarySlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => GlossaryRoute
          })
const LawyerSeoIndexRoute = LawyerSeoIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LawyerSeoRoute
          })
const LawyerSeoSlugRoute = LawyerSeoSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => LawyerSeoRoute
          })
const PracticeAreasIndexRoute = PracticeAreasIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PracticeAreasRoute
          })
const PracticeAreasSlugRoute = PracticeAreasSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => PracticeAreasRoute
          })
const PracticeAreasBankruptcyLawyerSeoRoute = PracticeAreasBankruptcyLawyerSeoRouteImport.update({
            id: '/bankruptcy-lawyer-seo',path: '/bankruptcy-lawyer-seo',getParentRoute: () => PracticeAreasRoute
          })
const PracticeAreasCorporateBusinessLawyerSeoRoute = PracticeAreasCorporateBusinessLawyerSeoRouteImport.update({
            id: '/corporate-business-lawyer-seo',path: '/corporate-business-lawyer-seo',getParentRoute: () => PracticeAreasRoute
          })
const PracticeAreasCriminalDefenseLawyerSeoRoute = PracticeAreasCriminalDefenseLawyerSeoRouteImport.update({
            id: '/criminal-defense-lawyer-seo',path: '/criminal-defense-lawyer-seo',getParentRoute: () => PracticeAreasRoute
          })
const PracticeAreasDuiDwiLawyerSeoRoute = PracticeAreasDuiDwiLawyerSeoRouteImport.update({
            id: '/dui-dwi-lawyer-seo',path: '/dui-dwi-lawyer-seo',getParentRoute: () => PracticeAreasRoute
          })
const PracticeAreasEmploymentLawLawyerSeoRoute = PracticeAreasEmploymentLawLawyerSeoRouteImport.update({
            id: '/employment-law-lawyer-seo',path: '/employment-law-lawyer-seo',getParentRoute: () => PracticeAreasRoute
          })
const PracticeAreasEstatePlanningLawyerSeoRoute = PracticeAreasEstatePlanningLawyerSeoRouteImport.update({
            id: '/estate-planning-lawyer-seo',path: '/estate-planning-lawyer-seo',getParentRoute: () => PracticeAreasRoute
          })
const PracticeAreasFamilyLawLawyerSeoRoute = PracticeAreasFamilyLawLawyerSeoRouteImport.update({
            id: '/family-law-lawyer-seo',path: '/family-law-lawyer-seo',getParentRoute: () => PracticeAreasRoute
          })
const PracticeAreasImmigrationLawyerSeoRoute = PracticeAreasImmigrationLawyerSeoRouteImport.update({
            id: '/immigration-lawyer-seo',path: '/immigration-lawyer-seo',getParentRoute: () => PracticeAreasRoute
          })
const PracticeAreasMedicalMalpracticeLawyerSeoRoute = PracticeAreasMedicalMalpracticeLawyerSeoRouteImport.update({
            id: '/medical-malpractice-lawyer-seo',path: '/medical-malpractice-lawyer-seo',getParentRoute: () => PracticeAreasRoute
          })
const PracticeAreasPersonalInjuryLawyerSeoRoute = PracticeAreasPersonalInjuryLawyerSeoRouteImport.update({
            id: '/personal-injury-lawyer-seo',path: '/personal-injury-lawyer-seo',getParentRoute: () => PracticeAreasRoute
          })
const PracticeAreasRealEstateLawLawyerSeoRoute = PracticeAreasRealEstateLawLawyerSeoRouteImport.update({
            id: '/real-estate-law-lawyer-seo',path: '/real-estate-law-lawyer-seo',getParentRoute: () => PracticeAreasRoute
          })
const PracticeAreasTaxLawLawyerSeoRoute = PracticeAreasTaxLawLawyerSeoRouteImport.update({
            id: '/tax-law-lawyer-seo',path: '/tax-law-lawyer-seo',getParentRoute: () => PracticeAreasRoute
          })
const PracticeAreasWorkersCompensationLawyerSeoRoute = PracticeAreasWorkersCompensationLawyerSeoRouteImport.update({
            id: '/workers-compensation-lawyer-seo',path: '/workers-compensation-lawyer-seo',getParentRoute: () => PracticeAreasRoute
          })
const ServicesIndexRoute = ServicesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ServicesRoute
          })
const ServicesSlugRoute = ServicesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => ServicesRoute
          })
const ServicesAiSeoGeoRoute = ServicesAiSeoGeoRouteImport.update({
            id: '/ai-seo-geo',path: '/ai-seo-geo',getParentRoute: () => ServicesRoute
          })
const ServicesLawFirmMarketingAnalyticsRoute = ServicesLawFirmMarketingAnalyticsRouteImport.update({
            id: '/law-firm-marketing-analytics',path: '/law-firm-marketing-analytics',getParentRoute: () => ServicesRoute
          })
const ServicesLawFirmSeoRoute = ServicesLawFirmSeoRouteImport.update({
            id: '/law-firm-seo',path: '/law-firm-seo',getParentRoute: () => ServicesRoute
          })
const ServicesLawFirmWebsiteDevelopmentRoute = ServicesLawFirmWebsiteDevelopmentRouteImport.update({
            id: '/law-firm-website-development',path: '/law-firm-website-development',getParentRoute: () => ServicesRoute
          })
const ServicesLeadGenerationForLawFirmsRoute = ServicesLeadGenerationForLawFirmsRouteImport.update({
            id: '/lead-generation-for-law-firms',path: '/lead-generation-for-law-firms',getParentRoute: () => ServicesRoute
          })
const ServicesLegalContentWritingRoute = ServicesLegalContentWritingRouteImport.update({
            id: '/legal-content-writing',path: '/legal-content-writing',getParentRoute: () => ServicesRoute
          })
const ServicesLinkBuildingForLawFirmsRoute = ServicesLinkBuildingForLawFirmsRouteImport.update({
            id: '/link-building-for-law-firms',path: '/link-building-for-law-firms',getParentRoute: () => ServicesRoute
          })
const ServicesLocalSeoForLawFirmsRoute = ServicesLocalSeoForLawFirmsRouteImport.update({
            id: '/local-seo-for-law-firms',path: '/local-seo-for-law-firms',getParentRoute: () => ServicesRoute
          })
const ServicesPpcForLawFirmsRoute = ServicesPpcForLawFirmsRouteImport.update({
            id: '/ppc-for-law-firms',path: '/ppc-for-law-firms',getParentRoute: () => ServicesRoute
          })
const ServicesSocialMediaMarketingForLawFirmsRoute = ServicesSocialMediaMarketingForLawFirmsRouteImport.update({
            id: '/social-media-marketing-for-law-firms',path: '/social-media-marketing-for-law-firms',getParentRoute: () => ServicesRoute
          })
const ServicesTechnicalSeoForLawFirmsRoute = ServicesTechnicalSeoForLawFirmsRouteImport.update({
            id: '/technical-seo-for-law-firms',path: '/technical-seo-for-law-firms',getParentRoute: () => ServicesRoute
          })
const UkDigitalMarketingForSolicitorsRoute = UkDigitalMarketingForSolicitorsRouteImport.update({
            id: '/uk/digital-marketing-for-solicitors',path: '/uk/digital-marketing-for-solicitors',getParentRoute: () => rootRouteImport
          })
const UkLocalSeoForSolicitorsRoute = UkLocalSeoForSolicitorsRouteImport.update({
            id: '/uk/local-seo-for-solicitors',path: '/uk/local-seo-for-solicitors',getParentRoute: () => rootRouteImport
          })
const UkSeoForSolicitorsRoute = UkSeoForSolicitorsRouteImport.update({
            id: '/uk/seo-for-solicitors',path: '/uk/seo-for-solicitors',getParentRoute: () => rootRouteImport
          })
const BlogPagePageRoute = BlogPagePageRouteImport.update({
            id: '/page/$page',path: '/page/$page',getParentRoute: () => BlogRoute
          })





const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute,BlogPagePageRoute: BlogPagePageRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)




const CaseStudiesRouteChildren = {
  CaseStudiesSlugRoute: CaseStudiesSlugRoute,CaseStudiesIndexRoute: CaseStudiesIndexRoute
}

const CaseStudiesRouteWithChildren = CaseStudiesRoute._addFileChildren(CaseStudiesRouteChildren)




const GlossaryRouteChildren = {
  GlossarySlugRoute: GlossarySlugRoute,GlossaryIndexRoute: GlossaryIndexRoute
}

const GlossaryRouteWithChildren = GlossaryRoute._addFileChildren(GlossaryRouteChildren)




const LawyerSeoRouteChildren = {
  LawyerSeoSlugRoute: LawyerSeoSlugRoute,LawyerSeoIndexRoute: LawyerSeoIndexRoute
}

const LawyerSeoRouteWithChildren = LawyerSeoRoute._addFileChildren(LawyerSeoRouteChildren)




const PracticeAreasRouteChildren = {
  PracticeAreasSlugRoute: PracticeAreasSlugRoute,PracticeAreasBankruptcyLawyerSeoRoute: PracticeAreasBankruptcyLawyerSeoRoute,PracticeAreasCorporateBusinessLawyerSeoRoute: PracticeAreasCorporateBusinessLawyerSeoRoute,PracticeAreasCriminalDefenseLawyerSeoRoute: PracticeAreasCriminalDefenseLawyerSeoRoute,PracticeAreasDuiDwiLawyerSeoRoute: PracticeAreasDuiDwiLawyerSeoRoute,PracticeAreasEmploymentLawLawyerSeoRoute: PracticeAreasEmploymentLawLawyerSeoRoute,PracticeAreasEstatePlanningLawyerSeoRoute: PracticeAreasEstatePlanningLawyerSeoRoute,PracticeAreasFamilyLawLawyerSeoRoute: PracticeAreasFamilyLawLawyerSeoRoute,PracticeAreasImmigrationLawyerSeoRoute: PracticeAreasImmigrationLawyerSeoRoute,PracticeAreasMedicalMalpracticeLawyerSeoRoute: PracticeAreasMedicalMalpracticeLawyerSeoRoute,PracticeAreasPersonalInjuryLawyerSeoRoute: PracticeAreasPersonalInjuryLawyerSeoRoute,PracticeAreasRealEstateLawLawyerSeoRoute: PracticeAreasRealEstateLawLawyerSeoRoute,PracticeAreasTaxLawLawyerSeoRoute: PracticeAreasTaxLawLawyerSeoRoute,PracticeAreasWorkersCompensationLawyerSeoRoute: PracticeAreasWorkersCompensationLawyerSeoRoute,PracticeAreasIndexRoute: PracticeAreasIndexRoute
}

const PracticeAreasRouteWithChildren = PracticeAreasRoute._addFileChildren(PracticeAreasRouteChildren)




const ServicesRouteChildren = {
  ServicesSlugRoute: ServicesSlugRoute,ServicesAiSeoGeoRoute: ServicesAiSeoGeoRoute,ServicesLawFirmMarketingAnalyticsRoute: ServicesLawFirmMarketingAnalyticsRoute,ServicesLawFirmSeoRoute: ServicesLawFirmSeoRoute,ServicesLawFirmWebsiteDevelopmentRoute: ServicesLawFirmWebsiteDevelopmentRoute,ServicesLeadGenerationForLawFirmsRoute: ServicesLeadGenerationForLawFirmsRoute,ServicesLegalContentWritingRoute: ServicesLegalContentWritingRoute,ServicesLinkBuildingForLawFirmsRoute: ServicesLinkBuildingForLawFirmsRoute,ServicesLocalSeoForLawFirmsRoute: ServicesLocalSeoForLawFirmsRoute,ServicesPpcForLawFirmsRoute: ServicesPpcForLawFirmsRoute,ServicesSocialMediaMarketingForLawFirmsRoute: ServicesSocialMediaMarketingForLawFirmsRoute,ServicesTechnicalSeoForLawFirmsRoute: ServicesTechnicalSeoForLawFirmsRoute,ServicesIndexRoute: ServicesIndexRoute
}

const ServicesRouteWithChildren = ServicesRoute._addFileChildren(ServicesRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,BestLawFirmSeoCompaniesRoute: BestLawFirmSeoCompaniesRoute,BlogRoute: BlogRouteWithChildren,CaseStudiesRoute: CaseStudiesRouteWithChildren,ContactRoute: ContactRoute,GlossaryRoute: GlossaryRouteWithChildren,GuidesRoute: GuidesRoute,LawFirmSeoAuditRoute: LawFirmSeoAuditRoute,LawyerSeoRoute: LawyerSeoRouteWithChildren,PracticeAreasRoute: PracticeAreasRouteWithChildren,PricingRoute: PricingRoute,ServicesRoute: ServicesRouteWithChildren,UkDigitalMarketingForSolicitorsRoute: UkDigitalMarketingForSolicitorsRoute,UkLocalSeoForSolicitorsRoute: UkLocalSeoForSolicitorsRoute,UkSeoForSolicitorsRoute: UkSeoForSolicitorsRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)